// Charts for Dashboards
var PieChart = require('./dist/charts/pie-chart');
var DonutChart = require('./dist/charts/donut-chart');
var PieRadarChart = require('./dist/charts/pie-radar-chart');
var LineChart = require('./dist/charts/line-chart');
var HorizontalBarChart = require('./dist/charts/horizontal-bar-chart');
var VerticalBarChart = require('./dist/charts/vertical-bar-chart');
var RadarChart = require('./dist/charts/radar-chart');
var DivergingBarChart = require('./dist/charts/diverging-bar-chart');
var RadialBarChart = require('./dist/charts/radial-bar-chart');

// Charts for Chart builder
var AdvancedHorizontalBarChart = require('./dist/charts/advanced-horizontal-bar-chart');
var AdvancedVerticalBarChart = require('./dist/charts/advanced-vertical-bar-chart');

function getDashboardChart(name) {
  var available = {
    pie_chart: PieChart,
    donut_chart: DonutChart,
    pie_radar_chart: PieRadarChart,
    line_chart: LineChart,
    horizontal_bar_chart: HorizontalBarChart,
    diverging_bar_chart: DivergingBarChart,
    radar_chart: RadarChart,
    radial_bar_chart: RadialBarChart,
    vertical_bar_chart: VerticalBarChart,
  };

  return (available[name] || VerticalBarChart).default;
}

function getChartBuilderChart(name) {
  var available = {
    advanced_horizontal_bar_chart: AdvancedHorizontalBarChart,
    advanced_vertical_bar_chart: AdvancedVerticalBarChart,
  };

  return (available[name] || AdvancedVerticalBarChart).default;
}

module.exports = {
  getDashboardChart: getDashboardChart,
  getChartBuilderChart: getChartBuilderChart
};
